import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91281dc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-card" }
const _hoisted_2 = {
  key: 0,
  class: "img-wrap"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, [
  /*#__PURE__*/_createTextVNode("Learn More "),
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "feather feather-arrow-right"
  }, [
    /*#__PURE__*/_createElementVNode("line", {
      x1: "5",
      y1: "12",
      x2: "19",
      y2: "12"
    }),
    /*#__PURE__*/_createElementVNode("polyline", { points: "12 5 19 12 12 19" })
  ])
], -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isFlipped)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "service-card-image",
            src: require(`@/assets/${_ctx.image_path}`),
            alt: "service-image"
          }, null, 8, _hoisted_3),
          _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isFlipped)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "learn-more",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.flipCard()))
        }, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.isFlipped)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "card-reverse",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.flipCard()))
        }, [
          _createElementVNode("p", null, _toDisplayString(_ctx.description), 1),
          _createElementVNode("button", {
            onMousedown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$store.state.estimate_popup_open = true))
          }, "Request Quote", 32)
        ]))
      : _createCommentVNode("", true)
  ]))
}